import axios from 'axios'
import { defineStore } from 'pinia'

const errorMessage = error => error.response?.data?.message ?? 'We could not load your holiday schedule. Please try again.'

export const useHolidaysPublicStore = defineStore('holidaysPublic', {
  state: () => ({
    items: [],
    company: null,
    isLoading: false,
    savingIds: [],
    error: null,
  }),

  actions: {
    async fetchSchedule(companyUuid) {
      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.get(`/api/customer-accounts/${companyUuid}/holidays`)
        this.items = data.data
        this.company = data.company
      } catch (error) {
        this.items = []
        this.company = null
        this.error = errorMessage(error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async saveHoliday(companyUuid, ciaHolidayId, schedule) {
      this.savingIds.push(ciaHolidayId)
      this.error = null

      try {
        const { data } = await axios.put(`/api/customer-accounts/${companyUuid}/holidays/${ciaHolidayId}/confirmation`, schedule)
        this.patchHoliday(data.data)

        return data.data
      } catch (error) {
        this.error = errorMessage(error)
        throw error
      } finally {
        this.savingIds = this.savingIds.filter(id => id !== ciaHolidayId)
      }
    },

    async confirmAll(companyUuid, ciaHolidayIds) {
      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.put(`/api/customer-accounts/${companyUuid}/holiday-confirmations`, {
          cia_holiday_ids: ciaHolidayIds,
        })
        data.data.forEach(holiday => this.patchHoliday(holiday))

        return data.data
      } catch (error) {
        this.error = errorMessage(error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    patchHoliday(holiday) {
      const index = this.items.findIndex(item => item.holiday_id === holiday.holiday_id)

      if (index >= 0) {
        this.items.splice(index, 1, holiday)
      }
    },
  },
})
